import React, { useState } from "react";
import LilliSelect from "Components/LilliDesignSystem/LilliSelect";
import LilliButton from "Components/DesignSystemComponents/LilliButton/LilliButton";
import { postAddUserRoles } from "@intelligentlilli/api-layer";
import { SERVER } from "Services/config";
import styles from "./styles.module.scss";
import { useAppDispatch } from "State/hooks";
import { setRefreshStaff } from "State/slices/session-slice";
import theme from "../../Styles/theme.scss";
import { SuccessTickIcon } from "Styles/Icons/DesignSystem";
import { useNavigate } from "react-router-dom";

type OptionType = { value: string; label: string; id: string };

interface AssignRoleFormProps {
  staff: { value: number | string; label: string; id: string }[];
  onTrack: (eventProperties: Record<string, string>) => void;
  closeModal: () => void;
}

const AssignRole = ({ staff, onTrack, closeModal }: AssignRoleFormProps) => {
  const [selectedStaff, setSelectedStaff] = useState<OptionType | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const [success, setSuccess] = useState(false);

  const navigate = useNavigate();

  const dispatch = useAppDispatch();
  const onSubmit = async () => {
    setLoading(true);
    setError(null);

    try {
      await postAddUserRoles(SERVER, selectedStaff.id, "installer", "web");

      dispatch(setRefreshStaff(true));
      onTrack({ action: "form_submitted" });
      setSuccess(true);
    } catch (err) {
      console.error("Error assigning role:", err);
      setError("Failed to assign role. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      {!success && (
        <>
          <LilliSelect
            withinModal
            data-private
            placeholder="Select a staff member"
            options={staff}
            name="staff"
            onChange={setSelectedStaff}
            value={selectedStaff}
            isClearable
            isSearchable
            menuPlacement={"bottom"}
          />
          {error && <p className={styles.error}>{error}</p>}
          <div className={styles.button}>
            <LilliButton
              disabled={!selectedStaff}
              onClick={onSubmit}
              loading={loading}
            >
              Assign
            </LilliButton>
          </div>
        </>
      )}
      {success && (
        <div className={styles.success_container}>
          <SuccessTickIcon colour={theme.expected2} width={60} />
          <div className={styles.staff_splash_title}>
            Role assigned successfully!
          </div>
          <div className={styles.staff_splash_message}>
            <span
              className={styles.clickable_name}
              onClick={() => navigate(`/staff/${selectedStaff?.id}`)}
            >
              {selectedStaff?.label}
            </span>{" "}
            has been assigned the Installer role
          </div>
          <div>
            <LilliButton
              onClick={() => {
                closeModal();
                setSelectedStaff(null);
              }}
              className={styles.button}
            >
              Done
            </LilliButton>
          </div>
        </div>
      )}
    </div>
  );
};

export default AssignRole;
